// FAQ Toggle
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".faq-question").forEach(button => {
        button.addEventListener("click", () => {
            const expanded = button.getAttribute("aria-expanded") === "true";
            if (expanded) {
                button.setAttribute("aria-expanded", "false");
                button.nextElementSibling.classList.remove("active");
            } else {
                button.setAttribute("aria-expanded", "true");
                button.nextElementSibling.classList.add("active");
            }
        });
    });
});
// FAQ Toggle

